import BusinessIcon from "@material-ui/icons/Business";
import HomeIcon from "@material-ui/icons/Home";
import ListIcon from "@material-ui/icons/List";
import PersonIcon from "@material-ui/icons/Person";
import PlaceIcon from "@material-ui/icons/Place";
/* eslint-disable react/display-name */
import React from "react";

import AdGroupSelectionSlide from "../views/CampaignCreationBasicSlides/AdGroupSelectionSlide";
import AdvertiserSelectionSlide from "../views/CampaignCreationBasicSlides/AdvertiserSelectionSlide";
import CRMRetargetinSegmentsPage from "../pages/CRMRetargetingSegmentsPage";
import CampaignBasicDetailsSlide from "../views/CampaignCreationBasicSlides/CampaignBasicDetailsSlide";
import CampaignSummarySlide from "../views/CampaignCreationBasicSlides/CampaignSummarySlide";
import CampaignTemplateBasicDetailsSlide from "../views/CampaignCreationBasicSlides/CampaignTemplateBasicDetailsSlide";
import CampaignTemplateSummarySlide from "../views/CampaignTemplateSummarySlide";
import LandingPageSelectionSlide from "../views/CampaignCreationBasicSlides/LandingPageSelectionSlide";
import PublicationListSelectionSlide from "../views/CampaignCreationCustomSlides/PublicationListSelectionSlide";
import RoleTitleSelectionSlide from "../views/CampaignCreationBasicSlides/RoleTitleSelectionSlide";
import SelectHubspotTargetCompaniesSlide from "../views/CampaignCreationBasicSlides/SelectHubspotTargetCompaniesSlide";
import StateProvinceSelectionSlide from "../views/CampaignCreationCustomSlides/StateProvinceSelectionSlide";
import VisitorsRetargetingSegmentsPage from "../pages/VisitorsRetargetingSegmentsPage";
import ZipCodeSelectionSlide from "../views/CampaignCreationCustomSlides/ZipCodeSelectionSlide";
import { BaseStep, BaseStepComponentProps } from "../components/modules/BaseStepper/BaseStepper";
import { CAMPAIGN_STEPS } from "../types/campaignTypes";

export const steps: BaseStep[] = [
  {
    order: 1,
    label: "Select Advertiser",
    name: CAMPAIGN_STEPS.SELECT_ADVERTISER,
    stepComponent: (props: BaseStepComponentProps) => <AdvertiserSelectionSlide {...props} />,
  },
  {
    order: 2,
    label: "Campaign Details",
    name: CAMPAIGN_STEPS.CAMPAIGN_DETAILS,
    stepComponent: (props: BaseStepComponentProps) => <CampaignBasicDetailsSlide {...props} />,
  },
  {
    order: 8,
    label: "Landing Page",
    name: CAMPAIGN_STEPS.LANDING_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <LandingPageSelectionSlide {...props} />,
  },
  {
    order: 9,
    label: "Ad Group",
    name: CAMPAIGN_STEPS.AD_GROUP_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <AdGroupSelectionSlide {...props} />,
  },
  {
    order: 10,
    label: "Summary",
    name: CAMPAIGN_STEPS.SUMMURY_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <CampaignSummarySlide {...props} />,
  },
];

export const templateSteps: BaseStep[] = [
  {
    order: 1,
    label: "Select Advertiser",
    name: CAMPAIGN_STEPS.SELECT_ADVERTISER,
    stepComponent: (props: BaseStepComponentProps) => <AdvertiserSelectionSlide {...props} />,
  },
  {
    order: 2,
    label: "Campaign Template Details",
    name: CAMPAIGN_STEPS.CAMPAIGN_TEMPLATE_DETAILS,
    stepComponent: (props: BaseStepComponentProps) => <CampaignTemplateBasicDetailsSlide {...props} />,
  },
  {
    order: 8,
    label: "Landing Page",
    name: CAMPAIGN_STEPS.LANDING_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <LandingPageSelectionSlide {...props} />,
  },
  {
    order: 9,
    label: "Ad Group",
    name: CAMPAIGN_STEPS.AD_GROUP_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <AdGroupSelectionSlide {...props} />,
  },
  {
    order: 10,
    label: "Summary",
    name: CAMPAIGN_STEPS.SUMMURY_PAGE,
    stepComponent: (props: BaseStepComponentProps) => <CampaignTemplateSummarySlide {...props} />,
  },
];

export const StateProvinceSelectionStep: BaseStep = {
  order: 7,
  label: "State/Province",
  name: CAMPAIGN_STEPS.STATE_PROVINCES,
  stepComponent: (props: BaseStepComponentProps) => <StateProvinceSelectionSlide {...props} />,
};

export const VisitorsRetargetingSegmentsSelectionStep: BaseStep = {
  order: 7,
  label: "Visitors Re-targeting Segments",
  name: CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS,
  stepComponent: (props: BaseStepComponentProps) => <VisitorsRetargetingSegmentsPage {...props} />,
};

export const CRMRetargetingSegmentsSelectionStep: BaseStep = {
  order: 7,
  label: "CRM Re-targeting Segments",
  name: CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS,
  stepComponent: (props: BaseStepComponentProps) => <CRMRetargetinSegmentsPage {...props} />,
};

export const ZipCodeSelectionStep: BaseStep = {
  order: 6,
  label: "Zip Codes",
  name: CAMPAIGN_STEPS.ZIP_CODES,
  stepComponent: (props: BaseStepComponentProps) => <ZipCodeSelectionSlide {...props} />,
};

export const PublicationListSelectionStep: BaseStep = {
  order: 5,
  label: "Publication Lists",
  name: CAMPAIGN_STEPS.PUBLICATION_LISTS,
  stepComponent: (props: BaseStepComponentProps) => <PublicationListSelectionSlide {...props} />,
};

export const RoleTitleSelectionStep: BaseStep = {
  order: 3,
  label: "Role/Title",
  name: CAMPAIGN_STEPS.ROLE_TITLES,
  stepComponent: (props: BaseStepComponentProps) => <RoleTitleSelectionSlide {...props} />,
};

export const TargetCompaniesSelectionStep: BaseStep = {
  order: 4,
  label: "Target Companies",
  name: CAMPAIGN_STEPS.TARGET_COMPANIES,
  stepComponent: (props: BaseStepComponentProps) => <SelectHubspotTargetCompaniesSlide {...props} />,
};

export const stepOptions = [
  {
    name: CAMPAIGN_STEPS.STATE_PROVINCES,
    label: "Geography (State / Province)",
    description: "Target audiences using U.S. State and Canada Provinces.",
    icon: <PlaceIcon />,
  },
  {
    name: CAMPAIGN_STEPS.ZIP_CODES,
    label: "Geography (ZIP Code)",
    description: "Target audiences using U.S. Zip Codes.",
    icon: <HomeIcon />,
  },
  {
    name: CAMPAIGN_STEPS.PUBLICATION_LISTS,
    label: "Publication Lists",
    description: "Target audiences using BrandGen verified publications or upload your own publication list.",
    icon: <ListIcon />,
  },
  {
    name: CAMPAIGN_STEPS.TARGET_COMPANIES,
    label: "Company Domain",
    description: "Target Account-Based audiences using company domains.",
    icon: <BusinessIcon />,
  },
  {
    name: CAMPAIGN_STEPS.ROLE_TITLES,
    label: "Role / Title",
    description: "Target audiences using BrandGen curated Job Role and Title categories.",
    icon: <PersonIcon />,
  },
  {
    name: CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS,
    label: "Visitors Re-targeting Segments",
    description: "Target audiences using BrandGen segments that you have previously targeted.",
    icon: <PersonIcon />,
  },
  {
    name: CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS,
    label: "CRM Re-targeting Segments",
    description: "Target audiences using CRM Re-targeting Segments.",
    icon: <PersonIcon />,
  },
];

export const stepMap: Record<string, BaseStep> = {
  [CAMPAIGN_STEPS.ROLE_TITLES]: RoleTitleSelectionStep,
  [CAMPAIGN_STEPS.TARGET_COMPANIES]: TargetCompaniesSelectionStep,
  [CAMPAIGN_STEPS.PUBLICATION_LISTS]: PublicationListSelectionStep,
  [CAMPAIGN_STEPS.ZIP_CODES]: ZipCodeSelectionStep,
  [CAMPAIGN_STEPS.STATE_PROVINCES]: StateProvinceSelectionStep,
  [CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS]: VisitorsRetargetingSegmentsSelectionStep,
  [CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS]: CRMRetargetingSegmentsSelectionStep,
};

export const basicSteps: CAMPAIGN_STEPS[] = [
  CAMPAIGN_STEPS.SELECT_ADVERTISER,
  CAMPAIGN_STEPS.CAMPAIGN_DETAILS,
  CAMPAIGN_STEPS.CAMPAIGN_TEMPLATE_DETAILS,
  CAMPAIGN_STEPS.LANDING_PAGE,
  CAMPAIGN_STEPS.SUMMURY_PAGE,
  CAMPAIGN_STEPS.AD_GROUP_PAGE,
  CAMPAIGN_STEPS.ZIP_CODES,
  CAMPAIGN_STEPS.ROLE_TITLES,
  CAMPAIGN_STEPS.STATE_PROVINCES,
];
